<div class="dialog-container">
  <div class="dialog-header">
    @if (step === 1) {
      <h1 class="dialog-title">Importador de Contas a Pagar</h1>
    }
    @if (step === 2) {
      <h1 class="dialog-title">Pré-visualização da importação</h1>
    }

    <button mat-icon-button (click)="cancelar()" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (step === 1) {
    <div class="dialog-content">
      <div class="actions-row">
        <input #fileInput type="file" (change)="onFileSelected($event)" accept=".csv" hidden />
        <button
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="fileInput.click()"
          [disabled]="isLoading">
          @if (!isLoading) {
            <mat-icon class="material-symbols-outlined">upload</mat-icon>
          }
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          {{ isLoading ? '' : 'carregar planilha de contas a pagar' }}
        </button>
        <button mat-button (click)="downloadModelo()">
          <mat-icon class="material-symbols-outlined">download</mat-icon>
          download da planilha de exemplo
        </button>
      </div>
      <p class="instructions-text">
        Serão inseridas na base de dados APENAS novas parcelas conforme descrito na planilha.<br />
        Selecione um arquivo no formato texto (.csv) separado por ";".<br />
        O arquivo deverá ser compatível com o layout fornecido pela ATS, não excedendo o limite de 2Mb.
      </p>
      @if (errorMessage) {
        <mat-error class="mb-3 d-block">
          <mat-icon class="align-middle">error</mat-icon> {{ errorMessage }}
        </mat-error>
      }
      <div class="table-section">
        <h3 class="table-title">Exemplo de planilha compatível com o Sistema ERP</h3>
        <div class="table-container">
          <table mat-table [dataSource]="dataSourceExample">
            <ng-container matColumnDef="dataCompetencia">
              <th mat-header-cell *matHeaderCellDef>Dt. Competência</th>
              <td mat-cell *matCellDef="let e">{{ e.dataCompetencia }}</td>
            </ng-container>
            <ng-container matColumnDef="dataVencimento">
              <th mat-header-cell *matHeaderCellDef>Dt. Vencimento</th>
              <td mat-cell *matCellDef="let e">{{ e.dataVencimento }}</td>
            </ng-container>
            <ng-container matColumnDef="dataPagamento">
              <th mat-header-cell *matHeaderCellDef>Dt. Pagamento</th>
              <td mat-cell *matCellDef="let e">{{ e.dataPagamento }}</td>
            </ng-container>
            <ng-container matColumnDef="valor">
              <th mat-header-cell *matHeaderCellDef>Valor</th>
              <td mat-cell *matCellDef="let e">{{ e.valor }}</td>
            </ng-container>
            <ng-container matColumnDef="categoria">
              <th mat-header-cell *matHeaderCellDef>Categoria</th>
              <td mat-cell *matCellDef="let e">{{ e.categoria }}</td>
            </ng-container>
            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let e">{{ e.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="clienteFornecedor">
              <th mat-header-cell *matHeaderCellDef>Fornecedor</th>
              <td mat-cell *matCellDef="let e">{{ e.clienteFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="emailClienteFornecedor">
              <th mat-header-cell *matHeaderCellDef>Email Fornecedor</th>
              <td mat-cell *matCellDef="let e">{{ e.emailClienteFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="numeroDocumentoClienteFornecedor">
              <th mat-header-cell *matHeaderCellDef>Doc. Fornecedor</th>
              <td mat-cell *matCellDef="let e">{{ e.numeroDocumentoClienteFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="clienteFornecedorEstrangeiro">
              <th mat-header-cell *matHeaderCellDef>Estr.</th>
              <td mat-cell *matCellDef="let e">{{ e.clienteFornecedorEstrangeiro }}</td>
            </ng-container>
            <ng-container matColumnDef="centroCusto">
              <th mat-header-cell *matHeaderCellDef>C. Custo</th>
              <td mat-cell *matCellDef="let e">{{ e.centroCusto }}</td>
            </ng-container>
            <ng-container matColumnDef="observacoes">
              <th mat-header-cell *matHeaderCellDef>Obs.</th>
              <td mat-cell *matCellDef="let e">{{ e.observacoes }}</td>
            </ng-container>
            <ng-container matColumnDef="formaPagamento">
              <th mat-header-cell *matHeaderCellDef>F. Pgto</th>
              <td mat-cell *matCellDef="let e">{{ e.formaPagamento }}</td>
            </ng-container>
            <ng-container matColumnDef="contaFinanceira">
              <th mat-header-cell *matHeaderCellDef>Conta Pgto</th>
              <td mat-cell *matCellDef="let e">{{ e.contaFinanceira }}</td>
            </ng-container>
            <ng-container matColumnDef="codigoBarras">
              <th mat-header-cell *matHeaderCellDef>Cód. Barras</th>
              <td mat-cell *matCellDef="let e">{{ e.codigoBarras }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsExample"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsExample"></tr>
          </table>
        </div>
      </div>
    </div>
  }

  @if (step === 2) {
    <div class="dialog-content">
      <div class="validation-header mb-3">
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'todos'"
          (click)="aplicarFiltro('todos')">
          <span class="metric-label">todos</span>
          <strong class="metric-value">{{ getResumoTotal() }}</strong>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'novos'"
          (click)="aplicarFiltro('novos')">
          <span class="metric-label"><span class="dot dot-green"></span> válidos</span>
          <span class="metric-value-sm">{{ getResumoNovos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'avisos'"
          (click)="aplicarFiltro('avisos')">
          <span class="metric-label"><span class="dot dot-yellow"></span> advertências</span>
          <span class="metric-value-sm">{{ getResumoAvisos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'erros'"
          (click)="aplicarFiltro('erros')">
          <span class="metric-label"><span class="dot dot-red"></span> erros</span>
          <span class="metric-value-sm">{{ getResumoErros() }}</span>
        </div>
      </div>
      <div class="table-container">
        <table mat-table [dataSource]="itemsFiltered">
          <ng-container matColumnDef="status" sticky>
            <th mat-header-cell *matHeaderCellDef class="w-status">Situação</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="w-status"
              [matTooltip]="getTooltip(element)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              <div class="status-dots">
                @if (element.isValido && !element.isAlerta) {
                  <span class="dot dot-green"></span>
                }
                @if (!element.isValido) {
                  <span class="dot dot-red"></span>
                }
                @if (element.isAlerta && element.isValido) {
                  <span class="dot dot-yellow"></span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="dataCompetencia">
            <th mat-header-cell *matHeaderCellDef>Dt. Competência</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.dataCompetencia }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dataVencimento">
            <th mat-header-cell *matHeaderCellDef>Dt. Vencimento</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.dataVencimento }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dataPagamento">
            <th mat-header-cell *matHeaderCellDef>Dt. Pagamento</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.dataPagamento }}
            </td>
          </ng-container>
          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.valor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="categoria">
            <th mat-header-cell *matHeaderCellDef>Categoria</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.categoria }}
            </td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.descricao }}
            </td>
          </ng-container>
          <ng-container matColumnDef="clienteFornecedor">
            <th mat-header-cell *matHeaderCellDef>Fornecedor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.clienteFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="emailClienteFornecedor">
            <th mat-header-cell *matHeaderCellDef>Email Fornecedor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.emailClienteFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="numeroDocumentoClienteFornecedor">
            <th mat-header-cell *matHeaderCellDef>Doc. Fornecedor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.numeroDocumentoClienteFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="clienteFornecedorEstrangeiro">
            <th mat-header-cell *matHeaderCellDef>Estr.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.clienteFornecedorEstrangeiro }}
            </td>
          </ng-container>
          <ng-container matColumnDef="centroCusto">
            <th mat-header-cell *matHeaderCellDef>C. Custo</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.centroCusto }}
            </td>
          </ng-container>
          <ng-container matColumnDef="observacoes">
            <th mat-header-cell *matHeaderCellDef>Obs.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.observacoes }}
            </td>
          </ng-container>
          <ng-container matColumnDef="formaPagamento">
            <th mat-header-cell *matHeaderCellDef>F. Pgto</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.formaPagamento }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contaFinanceira">
            <th mat-header-cell *matHeaderCellDef>Conta Pgto</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.contaFinanceira }}
            </td>
          </ng-container>
          <ng-container matColumnDef="codigoBarras">
            <th mat-header-cell *matHeaderCellDef>Cód. Barras</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.codigoBarras }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsPreview"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsPreview"
            [ngClass]="getRowClass(row)"></tr>
        </table>
        @if (itemsFiltered.length === 0) {
          <div class="empty-state p-4 text-center text-muted">Nenhum item encontrado neste filtro.</div>
        }
      </div>
    </div>
  }

  <div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <div class="actions-wrapper">
      @if (step === 1) {
        <button mat-stroked-button class="btn-secondary me-2 mobile-full-width" (click)="cancelar()">
          Cancelar
        </button>
      }

      @if (step === 2) {
        <button mat-stroked-button class="btn-secondary" (click)="voltarParaUpload()">
          <mat-icon class="material-symbols-outlined">refresh</mat-icon> escolher outro arquivo
        </button>
        <div
          class="button-tooltip-wrapper mobile-full-width"
          [matTooltip]="getButtonTooltip()"
          [matTooltipDisabled]="!isImportDisabled">
          <button
            mat-flat-button
            class="btn-primary w-100"
            [disabled]="isImportDisabled || isLoading"
            (click)="confirmarImportacao()">
            @if (isLoading === true) {
              <mat-spinner [diameter]="20"></mat-spinner>
            } @else {
              <span class="material-symbols-outlined">check</span> confirmar e gravar
            }
          </button>
        </div>
      }
    </div>
  </div>
</div>
